export default __webpack_public_path__ + "static/media/logo-fond-vert.a78126fb.png";